import React, {useState} from 'react'
import Typical from 'react-typical'
import MesCards from '../../../utils/MesCards'
import NavGalerieVirtuelle from '../../NavGalerieVirtuelle/NavGalerieVirtuelle'
import MapGalerieVirtuelle from '../../MapGalerieVirtuelle/MapGalerieVirtuelle'
import BgGV from '../../../assets/GV.jpg'
import './GalerieVirtuelle.css'
// import { useTranslation} from 'react-i18next';




const GalerieVirtuelle = () => {

// const { t } = useTranslation();
let firstFilter = MesCards.filter((item) => {
    return item.galerieVirtuel === true }) 
    
const [data,setData ] = useState(firstFilter)

    let newArray = []
    const FunctionModify = (e) => {
       
        let eTargetValue = e.target.value

        if(eTargetValue === "Tous"){
             
            setData(firstFilter)  

        }else{
            newArray = firstFilter.filter((item) => {
                return item.NameArtist[0] === eTargetValue})

            setData(newArray)
        }
    }


    return (
        <div className='container-fluid h-50 bg-light'>
           
            <div style={{backgroundImage: `url(${BgGV})`, height: 400+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} className="text-center h1 text-white p-2">
                
              <div>
                  
                  <h1 className="text-white mt-5 ml-5 text-left">
                        <div className="green">
                            <Typical loop = {Infinity} wrapper= "b" steps={['visit our virtual galleries_', 2500, 'an unforgettable trips_',2500]}/>
                        </div>
                   </h1>

              </div>

            </div>

            <NavGalerieVirtuelle  onClick={FunctionModify}  />
            <div className="container-fluid">
                <div className="row justify-content-md-center">
                    <MapGalerieVirtuelle  TransferProps={data} />
                </div>
            </div>

            
        </div>
    )
}

export default GalerieVirtuelle

